/**
 * @description 创建菜单
 * @param {Function} h createElement
 * @param {Object} menu 菜单项
 */
export function elMenuGroup(h, menu) {
  let icon = null
  if (menu.icon) icon = <i class={`fa fa-${menu.icon} menu-item-icon`} />
  // else if (menu.iconSvg) icon = <d2-icon-svg name={ menu.iconSvg }/>
  // else icon = <i class="fa fa-file-o"/>
  return <el-menu-item-group>
    {icon}
    <span slot="title">{menu.title || '未命名菜单'}</span>
    {menu.children.map(child => createMenu.call(this, h, child))}
  </el-menu-item-group>
}

/**
 * @description 创建菜单
 * @param {Function} h createElement
 * @param {Object} menu 菜单项
 */
export function elMenuItem(h, menu) {
  let icon = null
  if (menu.icon) icon = <div class="menu-icon"><i class={`fa fa-${menu.icon} menu-item-icon`} /></div>
  return <el-menu-item
    fid={menu.funcID}
    key={menu.path}
    index={menu.path}>
    {icon}
    <span slot="title" class="menu-title">{menu.title || '未命名菜单'}</span>
  </el-menu-item>
}

/**
 * @description 创建子菜单
 * @param {Function} h createElement
 * @param {Object} menu 菜单项
 */
export function elSubmenu(h, menu) {
  let icon = null
  if (menu.icon) icon = <div class="menu-icon" slot="title"><i class={`fa fa-${menu.icon} menu-item-icon`} /></div>
  return <el-submenu
    fid={menu.funcID}
    key={menu.path}
    index={menu.path}>
    {icon}
    <span slot="title" class="menu-title">{menu.title || '未命名菜单'}</span>
    {menu.children.map(child => createMenu.call(this, h, child))}
  </el-submenu>
}

/**
 * @description 在组件中调用此方法渲染菜单项目
 * @param {Function} h createElement
 * @param {Object} menu 菜单项
 */
export function createMenu(h, menu) {
  if (menu.group) return elMenuGroup.call(this, h, menu)
  if (!menu.children || menu.children.length < 1) return elMenuItem.call(this, h, menu)
  return elSubmenu.call(this, h, menu)
}

/**
 * 根据当前功能路径，查询对应的权限按钮
 * @param {*} allMenu 全部菜单
 * @param {*} curPath 当前路径
 */
export function findMenuBtn(allMenu, funcID) {
  let findBtnFunc = []
  for (let index = 0; index < allMenu.length; index++) {
    const element = allMenu[index];
    if (element.funcID === funcID) {
      findBtnFunc = element.btnFunc
      break;
    } else {
      if (element.children && element.children.length > 0) {
        let children = element.children
        findBtnFunc = findMenuBtn(children, funcID)
        if (findBtnFunc.length > 0) {
          break;
        }
      }
    }
  }
  return findBtnFunc
}
